<template>
  <div class="alarmImg">
    <div class="centerImg">
      <el-image
        style="width: 100%; height: 100%"
        :src="item.pictureUrl"
        fit="cover"
      />
    </div>
    <div class="centerTitle">
      <span>告警等级：{{ item.alarmLevel }}</span>
      <span>告警标题：{{ item.alarmName }}</span>
      <span>告警类型：{{ item.alarmTypeName }}</span>
      <span
        >告警时间：{{
          moment(parseInt(item.alarmTime)).format("YYYY-MM-DD HH:mm:ss")
        }}</span
      >
    </div>
    <div class="handleImg" v-show="item.alarmStatus == 1"></div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, ref, computed } from "vue";
import moment from "moment";
export default defineComponent({
  name: "alarmImg",
  props: {
    appearImgStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props) {
    const state = reactive({
      url: "http://50.136.50.141:9003/?featurevehicles/dn@2_0/80/82-7447556-95806",
      previewImg: [
        "http://50.136.50.141:9003/?featurevehicles/dn@2_0/80/82-7447556-95806",
      ],
    });
    const refData = toRefs(state);
    const changeSimilar = computed(() => {
      return parseInt(props.item.similar);
    });
    const changeArray = computed(() => {
      return [props.item.coverImage];
    });
    return {
      ...refData,
      moment,
      changeArray,
      changeSimilar,
    };
  },
});
</script>
<style lang="scss" scoped>
.alarmImg {
  width: 100%;
  height: 145px;
  border-radius: 10px;
  border: 2px solid;
  border-color: #f1f1f1;
  padding: 15px 10px;
  display: flex;
  position: relative;
  cursor: pointer;
  .centerTitle {
    width: 65%;
    height: 100%;
    padding: 15px 8px;
    color: #333;
    font-size: 14px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    span {
      margin: 6px 0;
    }
    @include flex-col-c-s;
  }
  .centerImg {
    width: 35%;
    height: 100%;
    // padding: 15px 0;
  }
  .handleImg {
    width: 75px;
    height: 75px;
    position: absolute;
    right: 27px;
    top: 0;
    top: 0;
    background: url("~@/assets/images/weichuli.png") no-repeat;
    background-size: 100% 100%;
  }
}
.regionalWanderingImg:hover {
  box-shadow: 0 0 10px #333;
}
</style>
